import styled from 'styled-components';

import { SpaceBetweenBlock } from '../../../styled';

export const Wrapper = styled.div`
  margin-top: 36px;
`;

export const SaveButtonWrapper = styled.div`
  margin-right: 12px;
  position: absolute;
  right: 0;
`;

export const ValueWrapper = styled(SpaceBetweenBlock)`
  color: ${(p) => p.theme.colors.muted};
  margin-bottom: 20px;
  padding: 0 12px;

  button {
    margin-left: 12px;
  }
`;

export const Value = styled(SpaceBetweenBlock)`
  color: ${(p) => p.theme.colors.brand};
  ${(p) => p.theme.typography.body};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
`;

export const Label = styled(SpaceBetweenBlock)`
  ${(p) => p.theme.typography.subHeader3compact};
  color: ${(p) => p.theme.colors.muted};

  margin-bottom: 20px;
`;
